<script setup lang="ts">
import type { ContentNavigationItem } from '@nuxt/content'
import { withLeadingSlash } from 'ufo'

function flattenPaths(navigation: ContentNavigationItem[]) {
  const result = []
  const stack = [...navigation].reverse()

  while (stack.length) {
    const node = stack.pop()!
    result.push(node.path)

    if (node.children) {
      for (let i = node.children.length - 1; i >= 0; i--)
        stack.push(node.children[i]!)
    }
  }

  return result
}

definePageMeta({
  middleware: async (to, _from) => {
    const nuxtApp = useNuxtApp()
    const navigation = await queryCollectionNavigation('content')
    const paths = flattenPaths(navigation)
    const slug = withLeadingSlash(nuxtApp.$i18n.locale.value + withLeadingSlash(Array.isArray(to.params.slug) ? to.params.slug.join('/') : to.params.slug))

    if (!paths.includes(slug))
      return navigateTo('/')
  },
})

const route = useRoute()
const { data: page } = await useAsyncData(route.path, () => {
  return queryCollection('content').path(route.path).first()
})
</script>

<template>
  <main class="mx-auto max-w-7xl px4 pb10 pb16 lg:px8 lg:py12 sm:px6">
    <ContentRenderer v-if="page" class="lg:prose-xl mx-auto prose" :value="page" />
  </main>
</template>
